import { typePrimaryColor } from './colors';

const typography = {
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  appH1: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.1
  },
  appH2: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1
  },
  h1: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.25
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.25
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.25
  },
  h4: {
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.25
  },
  h5: {
    fontSize: '1.0625rem',
    fontWeight: 500,
    lineHeight: 1.25
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.25
  },
  body1: {
    fontSize: 13
  },
  subtitle3: {
    fontSize: 10,
    lineHeight: 1,
    fontWeight: 400
  },
  subtitle4: {
    fontSize: 8,
    lineHeight: 1
  },
  button: {
    textTransform: 'none'
  },
  allVariants: {
    color: typePrimaryColor
  }
};

export default typography;
